enum RouteEndpointsMerks {
  BASE_MERKS = '/merk-list',
  EDIT_MERK = 'edit/:id',
  ADD_MERK = 'add',
}

export default RouteEndpointsMerks;
